module.exports = __webpack_public_path__ + "img/sld_inverter_green_t1_b1_dark.05da9065.svg";